import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '@/components/HomePage'

Vue.use(Router)

export default new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      component: HomePage,
      meta:{
        requireAuth:true
      },
      children:[
        { path: '/', redirect: '/quickQuery' },
        {
          path: '/quickQuery',
          name: 'quickQuery',
          component: () => import ('../views/quickQuery.vue')
        },
        {
          path: '/trafficQuery',
          name: 'trafficQuery',
          component: () => import ('../views/trafficQuery.vue')
        },
        {
          path: '/packageUse',
          name: 'packageUse',
          component: () => import ('../views/packageUse.vue')
        },
        {
          path: '/sms',
          name: 'sms',
          component: () => import ('../views/sms.vue')
        },
        {
          path: '/send',
          name: 'send',
          component: () => import ('../views/send.vue')
        },
        {
          path: '/reply',
          name: 'reply',
          component: () => import ('../views/reply.vue')
        },
        {
          path: '/play',
          name: 'play',
          component: () => import ('../views/play.vue')
        },
        {
          path: '/userCenter',
          name: 'userCenter',
          component: () => import ('../views/userCenter.vue')
        },
        {
          path: '/early',
          name: 'early',
          component: () => import ('../views/early.vue')
        },
        {
          path: '/comproblem',
          name: 'comproblem',
          component: () => import ('../views/comproblem.vue')
        },
        {
          path: '/productInt',
          name: 'productInt',
          component: () => import ('../views/productInt.vue')
        },
        {
          path: '/platform',
          name: 'platform',
          component: () => import ('../views/platform.vue')
        },
        {
          path: '/home',
          name: 'home',
          component: () => import ('../views/home.vue')
        },
        {
          path: '/userBind',
          name: 'userBind',
          component: () => import ('../views/userBind.vue')
        },
        {
          path: '/logistics',
          name: 'logistics',
          component: () => import ('../views/logistics.vue')
        },
        {
          path: '/smsRachg',
          name: 'smsRachg',
          component: () => import ('../views/smsRachg.vue')
        },
        {
          path: '/smsQuReg',
          name: 'smsQuReg',
          component: () => import ('../views/smsQuReg.vue')
        },
        {
          path: '/Record',
          name: 'Record',
          component: () => import ('../views/Record.vue')
        },
        {
          path: '/cardInfoH5',
          name: 'cardInfoH5',
          component: () => import ('../views/cardInfoH5/home.vue')
        },
        {
          path: '/payMent',
          name: 'payMent',
          component: () => import ('../views/cardInfoH5/payMent.vue')
        },
        {
          path: '/shareRecord',
          name: 'shareRecord',
          component: () => import ('../views/cardInfoH5/shareRecord.vue')
        },
        {
          path: '/cardH5',
          name: 'cardH5',
          component: () => import ('../views/cardH5/home.vue')
        },
        {
          path: '/cardPayMent',
          name: 'cardPayMent',
          component: () => import ('../views/cardH5/cardPayMent.vue')
        },
        {
          path: '/electronicInvoice',
          name: 'electronicInvoice',
          component: () => import ('../views/cardH5/electronicInvoice.vue')
        },
        {
          path: '/InvoiceIssued',
          name: 'InvoiceIssued',
          component: () => import ('../views/cardH5/InvoiceIssued.vue')
        },
        {
          path: '/InvoiceForm',
          name: 'InvoiceForm',
          component: () => import ('../views/cardH5/InvoiceForm.vue')
        },
        
        {
          path: '/UnissuedInvoice',
          name: 'UnissuedInvoice',
          component: () => import ('../views/cardH5/UnissuedInvoice.vue')
        },
        {
          path: '/cardRecord',
          name: 'cardRecord',
          component: () => import ('../views/cardH5/cardRecord.vue')
        },
        {
          path: '/cardQuery',
          name: 'cardQuery',
          component: () => import ('../views/cardH5/cardQuery.vue')
        },
        {
          path: '/cardDiagnosis',
          name: 'cardDiagnosis',
          component: () => import ('../views/cardH5/cardDiagnosis.vue')
        },
        {
          path: '/cardRemark',
          name: 'cardRemark',
          component: () => import ('../views/cardH5/cardRemark.vue')
        },
        {
          path: '/cardFlowInfo',
          name: 'cardFlowInfo',
          component: () => import ('../views/cardH5/cardFlowInfo.vue')
        },
        {
          path: '/voiceCardWhite',
          name: 'voiceCardWhite',
          component: () => import ('../views/cardH5/voiceCardWhite.vue')
        },
        {
          path: '/cardTrafficOverlay',
          name: 'cardTrafficOverlay',
          component: () => import ('../views/cardH5/cardTrafficOverlay.vue')
        },
        {
          path: '/cardVoiceOverlay',
          name: 'cardVoiceOverlay',
          component: () => import ('../views/cardH5/cardVoiceOverlay.vue')
        },
        {
          path: '/cardOverlayRecord',
          name: 'cardOverlayRecord',
          component: () => import ('../views/cardH5/cardOverlayRecord.vue')
        },
        {
          path: '/specialRecharge',
          name: 'specialRecharge',
          component: () => import ('../views/cardH5/specialRecharge.vue')
        },
        {
          path: '/specialRenew',
          name: 'specialRenew',
          component: () => import ('../views/cardH5/specialRenew.vue')
        },
        // {
        //   path: '/specialTrafficQuery',
        //   name: 'specialTrafficQuery',
        //   component: () => import ('../views/cardH5/specialTrafficQuery.vue')
        // },
        {
          path: '/voiceCardWhiteList',
          name: 'voiceCardWhiteList',
          component: () => import ('../views/voiceCardWhiteList.vue')
        },
        {
          path: '/OverlayRecords',
          name: 'OverlayRecords',
          component: () => import ('../views/OverlayRecords.vue')
        },
        {
          path: '/RenewalRecordswechat',
          name: 'RenewalRecordswechat',
          component: () => import ('../views/RenewalRecordswechat.vue')
        },
        {
          path: '/setTrafficOverlay',
          name: 'setTrafficOverlay',
          component: () => import ('../views/setTrafficOverlay.vue')
        },
        {
          path: '/flowPoolList',
          name: 'flowPoolList',
          component: () => import ('../views/flowPoolList.vue')
        },
        {
          path: '/flowPoolStacking',
          name: 'flowPoolStacking',
          component: () => import ('../views/flowPoolStacking.vue')
        },
        
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js